import { render, staticRenderFns } from "./ProjectTemplate2.vue?vue&type=template&id=f07b482e&scoped=true"
import script from "./ProjectTemplate2.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate2.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate2.vue?vue&type=style&index=0&id=f07b482e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b482e",
  null
  
)

export default component.exports